'use client';

import { show } from '@intercom/messenger-js-sdk';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { Button } from '@/components/ui/Button/button';
import { Env } from '@/consts/Env';
import { Link } from '@/i18n/routing';
import garlandsImage from '@/public/assets/image/not-found/christmas/garlands.webp';
import corssImage from '@/public/assets/image/not-found/default/cross.webp';

export const NotFoundPage = () => {
  const t = useTranslations('error');
  const isChristmasVersion = Env.NEXT_PUBLIC_APP_VARIANT === 'christmas';

  return (
    <div className="fixed inset-0 z-30 flex flex-col justify-center items-center min-h-screen bg-c900">

      {isChristmasVersion && (
        <>
          <Image src={garlandsImage} alt="garlands" width={500} height={200} className="absolute -top-6 sm:-top-16 md:top-0 md:-left-[5%] max-md:rotate-20 w-[120%] max-w-150 sm:w-full md:min-w-120 md:w-1/2 md:max-w-176" />
          <Image src={garlandsImage} alt="not-found" width={500} height={200} className="absolute -top-[4%] md:-right-[6%] rotate-28 min-w-md w-1/2 max-w-152 hidden md:block" />
        </>
      )}

      <div className="relative flex h-144 flex-col items-center gap-2.75 justify-center md:h-140 md:pt-21 md:gap-2.25">
        <h1 className="gradient-text bg-promo-banner-title-gradient bg-clip-text text-transparent text-[8.25rem] md:text-[14.375rem] font-medium leading-[120%] pt-0 max-md:-mt-2.5">404</h1>
        <p className="text-light text-[1.125rem] pt-5.5 leading-7 font-semibold md:text-2xl md:leading-[100%] md:font-medium text-center">
          {t('title')}
        </p>

        <p className="text-light text-[0.875rem] leading-5 font-regular text-center relative top-2 max-md:w-74">
          {t('description')}
        </p>

        <div
          className="flex justify-center gap-2 md:static max-md:fixed max-md:left-0 max-md:right-0 max-md:bottom-0 max-md:z-10 max-md:px-4 max-md:pt-4 max-md:pb-[max(1rem,env(safe-area-inset-bottom))] md:mt-10"
        >
          <Button
            onClick={() => show()}
            className="flex md:w-37.5 items-center px-11 py-3 paragraph-s-semibold"
            variant="secondary"
          >
            {t('contact-us')}
          </Button>
          <Button
            asChild
            className="flex md:w-37.5 items-center px-5.5 py-3 paragraph-s-semibold"
            variant="primary"
          >
            <Link href="/">{t('back-to-lobby')}</Link>
          </Button>
        </div>

        <Image src={corssImage} alt="cross" width={300} height={200} className="absolute top-[8%] md:top-[58%] -right-[5%] md:-right-[37%] size-20 md:size-28" />
        <Image src={corssImage} alt="cross" width={300} height={200} className="absolute top-[18%] md:top-[23%] left-[9%] md:-left-[9%] md:w-10.25 md:h-auto size-10 md:size-14 blur-[1px]" />
        <Image src={corssImage} alt="cross" width={300} height={200} className="absolute bottom-[12%] md:bottom-[3%] -left-[5%] md:-left-[45%] size-12 md:size-14 blur-[2px]" />
      </div>

      <div className="absolute top-1/4 md:top-1/4 -left-1/6 md:left-1/4 w-[130%] md:w-full h-1/3 md:h-[30%] bg-frame-gradient z-[-1] blur-[3.5rem] md:blur-[7rem] rounded-full opacity-30 md:opacity-40 rotate-[-10deg]"></div>

    </div>
  );
};
